import "../../styles.css";
// import "../../scss/theme-styles.scss"
import { meta } from "./metaObject";
import { header } from "../components/header";
const getOrigin = window.location.origin;
const getPath = window.location.pathname;
const fullURL = getOrigin + getPath;


const seo = () => {
    const getHeadInner = document.head.innerHTML;
    let notMetaData = true;
    let metaOutput = `
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta property="og:site_name" content="Brand">
        <meta property="og:type" content="website">   
        <meta property="og:url" content="${fullURL}">
        <link rel="icon" href="${getOrigin}/uploads/favicon-32x32.webp" sizes="32x32">
        <link rel="icon" href="${getOrigin}/uploads/favicon-192x192.webp" sizes="192x192">
        <link rel="apple-touch-icon" href="${getOrigin}/uploads/favicon-180x180.webp">
        <link rel="canonical" href="${fullURL}">
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap" rel="stylesheet">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css">
        <link rel="stylesheet" href="https://use.typekit.net/dky7qqb.css">
    `;
    meta.map((el, key) => {
        if (el.path == getPath) {
            metaOutput += `
                <title>${el.title ? el.title : 'PEMGARDA&reg; (pemivibart)'}</title>
                <meta property="og:title" content="${el.title ? el.title : 'PEMGARDA&reg; (pemivibart)'}">
                <meta name="description" content="${el.description}">
                <meta property="og:image" content="https://www.p360.com/wp-content/uploads/2025/09/Dashboard-1.png">
                <meta property="og:image:width" content="1440">
                <meta property="og:image:height" content="900">
                <meta property="og:image:type" content="image/png">
                <meta name="twitter:card" content="summary_large_image">
            `;
            metaOutput += getHeadInner;
            document.head.innerHTML = metaOutput;
            notMetaData = false;
        }
        else if (notMetaData) {
            notMetaData = false;
            metaOutput += getHeadInner;
            document.head.innerHTML = metaOutput;
        }
    })



}
seo();
// const mainWrapper = document.querySelector('main');
(function () {
    const isProduction = window.location.hostname === 'www.pemgarda.com';

    const scriptId = isProduction
        ? '01987b66-7745-793c-ace4-41f042d242db'
        : '01987b66-7745-793c-ace4-41f042d242db-test';

    window.OptanonWrapper = function () { };

    const autoBlock = document.createElement('script');
    autoBlock.src = `https://cdn.cookielaw.org/consent/${scriptId}/OtAutoBlock.js`;
    document.head.appendChild(autoBlock);

    const sdkStub = document.createElement('script');
    sdkStub.src = `https://cdn.cookielaw.org/consent/${scriptId}/otSDKStub.js`;
    sdkStub.setAttribute('data-domain-script', scriptId);

    sdkStub.onload = function () { // Forminator script giving issue to be removed from the analytics
        // GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });

        const gtm = document.createElement('script');
        gtm.async = true;
        gtm.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-P2X7QM94';
        document.head.appendChild(gtm);

        // Add iframe to <body> on production only
        if (isProduction) { 
            const addIframe = () => {
                const iframe = document.createElement('iframe');
                iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-P2X7QM94';
                iframe.height = '0';
                iframe.width = '0';
                iframe.style.display = 'none';
                iframe.style.visibility = 'hidden';

                document.body.insertAdjacentElement('afterbegin', iframe);
            };

            if (document.body) {
                addIframe();
            } else {
                window.addEventListener('DOMContentLoaded', addIframe);
            }
        }
    };

    document.head.appendChild(sdkStub);
})();